// extracted by mini-css-extract-plugin
export default {"relativeTimeOutput":"styles_relative-time-output_wUNDw"};